import { connect } from 'react-redux'
import { getCurrenOptionGroupChoices } from '../selectors.js'
import OptionGroupQuestion from './OptionGroupQuestion.js'

const mapStateToProps = state => ({
  options: getCurrenOptionGroupChoices(state),
})

export default connect(mapStateToProps)(OptionGroupQuestion)



// WEBPACK FOOTER //
// ./src/components/OptionGroupQuestionContainer.js